import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import { Divider, Drawer } from "antd";

import { SubPageHeaderTitle } from "../../../../../shared/SubPageHeaderTitle";

import NaocDailyProductionStore from "../../../../productiondata/store/naocdailyproductionstore";

import { RythmChart } from "./plots/RythmChart";

const ResponsiveGridLayout = WidthProvider(Responsive);
export const RythmBaseView = observer(() => {
  const naocDailyProductionStore = useContext(NaocDailyProductionStore);
  return (
    <Drawer
      title={
        <SubPageHeaderTitle title="NAOC Production and Evacuation Rythm" />
      }
      placement="right"
      onClose={() => {
        naocDailyProductionStore.showNaocOilRythmDrawer = false;
      }}
      width={"80%"}
      visible={naocDailyProductionStore.showNaocOilRythmDrawer}
      bodyStyle={{ backgroundColor: "#F0F2F5" }}
      destroyOnClose={true}
    >
      <div className="ms-Grid" dir="ltr" style={{ width: "100%" }}>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <ResponsiveGridLayout
              className="layout"
              compactType="vertical"
              draggableCancel=".chart-container-control, .chart-container-controls, .highcharts-container, .highcharts-contextmenu, .highcharts-menu"
              breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
              cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
              autoSize={true}
              style={{ backgroundColor: "#F0F2F5" }}
              useCSSTransforms={true}
            >
              <div
                key="1"
                data-grid={{ x: 0, y: 0, w: 6, h: 3 }}
                style={{ backgroundColor: "white" }}
                className=" ms-motion-fadeIn"
              >
                <RythmChart
                  type="Oil"
                  fluidColor="#ef9a9a"
                  title={`<b>Oil Production (bopd)</b> <br/>@ ${naocDailyProductionStore.gridHeaderText}`}
                  seriesName="Oil (bopd)"
                  dataType="production"
                />
              </div>
              <div
                key="2"
                data-grid={{ x: 6, y: 0, w: 6, h: 3 }}
                style={{ backgroundColor: "white" }}
                className=" ms-motion-fadeIn"
              >
                <RythmChart
                  type="Gas"
                  fluidColor="#87d068"
                  title={`<b>Gas Production (mscf/d)</b> <br/>@ ${naocDailyProductionStore.gridHeaderText}`}
                  seriesName="Gas (mscf/d)"
                  dataType="production"
                />
              </div>
              <div
                key="3"
                data-grid={{ x: 0, y: 1, w: 6, h: 3 }}
                style={{ backgroundColor: "white" }}
                className=" ms-motion-fadeIn"
              >
                <RythmChart
                  type="NGL"
                  fluidColor="#021691"
                  title={`<b>NGL Production (bopd)</b> <br/>@ ${naocDailyProductionStore.gridHeaderText}`}
                  seriesName="NGL (bopd)"
                  dataType="production"
                />
              </div>
              <div
                key="4"
                data-grid={{ x: 6, y: 1, w: 6, h: 3 }}
                style={{ backgroundColor: "white" }}
                className=" ms-motion-fadeIn"
              >
                <RythmChart
                  type="Boe"
                  fluidColor="#FABA86"
                  title={`<b>BOEPD Production </b> <br/>@ ${naocDailyProductionStore.gridHeaderText}`}
                  seriesName="BOEPD"
                  dataType="production"
                />
              </div>
              <Divider>Evacuation</Divider>

              <div
                key="5"
                data-grid={{ x: 0, y: 2, w: 6, h: 3 }}
                style={{ backgroundColor: "white" }}
                className=" ms-motion-fadeIn"
              >
                <RythmChart
                  type="Oil"
                  fluidColor="red"
                  title={`<b>Oil Evacuation (bopd)</b> <br/>@ ${naocDailyProductionStore.gridHeaderText}`}
                  seriesName="Oil (bopd)"
                  dataType="evacuation"
                />
              </div>
              <div
                key="6"
                data-grid={{ x: 6, y: 2, w: 6, h: 3 }}
                style={{ backgroundColor: "white" }}
                className=" ms-motion-fadeIn"
              >
                <RythmChart
                  type="Gas"
                  fluidColor="green"
                  title={`<b>Gas Evacuation (mscf/d)</b> <br/>@ ${naocDailyProductionStore.gridHeaderText}`}
                  seriesName="Gas (mscf/d)"
                  dataType="evacuation"
                />
              </div>
              <div
                key="7"
                data-grid={{ x: 0, y: 3, w: 6, h: 3 }}
                style={{ backgroundColor: "white" }}
                className=" ms-motion-fadeIn"
              >
                <RythmChart
                  type="NGL"
                  fluidColor="#0627F7"
                  title={`<b>NGL Delivered (bopd)</b> <br/>@ ${naocDailyProductionStore.gridHeaderText}`}
                  seriesName="NGL (bopd)"
                  dataType="evacuation"
                />
              </div>
              <div
                key="8"
                data-grid={{ x: 6, y: 3, w: 6, h: 3 }}
                style={{ backgroundColor: "white" }}
                className=" ms-motion-fadeIn"
              >
                <RythmChart
                  type="Boe"
                  fluidColor="#F79646"
                  title={`<b>BOEPD Evacuation </b> <br/>@ ${naocDailyProductionStore.gridHeaderText}`}
                  seriesName="BOEPD"
                  dataType="evacuation"
                />
              </div>
            </ResponsiveGridLayout>
          </div>
        </div>
      </div>
    </Drawer>
  );
});

